export default {

  APP_URL_API : process.env.VUE_APP_API,
  APP_URL_API_EVOLUCION : process.env.VUE_APP_API_EVOLUCION,
  APP_URL_API_PRESUPUESTO: process.env.VUE_APP_API_PRESUPUESTO

}
